import { useContext } from "react";
import ReactDOM from "react-dom";
import { useState, useEffect } from "react";
import { CompletedOrdersTab, WaitingOrdersTab } from "./Orders.tsx";
import Report from "./Report";
import DefineProduct from "./DefineProduct.tsx";
import ShopSetting from "./ShopSetting.tsx";
import BasketMaker from "./BasketMaker";
import PanelFormatterHOC from "./PanelFormatterHOC.tsx";
import AdminOrdersContext, {
  AdminOrdersProvider,
} from "context/AdminOrdersContext.tsx";
import OrderModal from "./OrderModal.tsx";
import { connection } from "../../utils/apiConnection.ts";
import FinancialDepartment from "./Transaction/Transactions.jsx";
import WithAuthentication from "../../Authentication/AuthenticationContext.ts";
import { useParams } from "react-router-dom";
import UserContext from "context/UserContext";
import AdminOrder from "./AdminOrders";

export default function MainPanel({
  inputChangeHandler,
  inputFileHandler,
  changeHandler,
  otherInfo,
  setUpdater,
}) {
  const [updateProduct, setUpdaterProduct] = useState(false);

  return (
    <>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-setting"
          role="tabpanel"
          aria-labelledby="pills-setting-tab"
        >
          <PanelFormatterHOC
            title={["تنظیمات"]}
            label="shopSetting"
            components={[
              <ShopSetting
                inputChangeHandler={inputChangeHandler}
                changeHandler={changeHandler}
                otherInfo={otherInfo}
                inputFileHandler={inputFileHandler}
                setUpdater={setUpdater}
              />,
            ]}
          />
        </div>
        <div
          class="tab-pane fade"
          id="pills-define-product"
          role="tabpanel"
          aria-labelledby="pills-define-product-tab"
        >
          <PanelFormatterHOC
            title={["تعریف کالا"]}
            label="defineProduct"
            components={[
              <DefineProduct setUpdaterProduct={setUpdaterProduct} />,
            ]}
          />
        </div>
        <div
          class="tab-pane fade"
          id="pills-orders"
          role="tabpanel"
          aria-labelledby="pills-orders-tab"
        >
          <AdminOrdersProvider>
            <Orders />
          </AdminOrdersProvider>
        </div>
        <div
          class="tab-pane fade"
          id="pills-basket-maker"
          role="tabpanel"
          aria-labelledby="pills-basket-maker"
        >
          <PanelFormatterHOC
            title={["سبدساز"]}
            label="basket"
            components={[<BasketMaker updateProduct={updateProduct} />]}
          />
        </div>

        <div
          class="tab-pane fade"
          id="pills-finance"
          role="tabpanel"
          aria-labelledby="pills-finance"
        >
          <FinancialDepartment type={2} otherInfo={otherInfo} />
        </div>
      </div>
    </>
  );
}

export function Orders({ pageName }) {
  const { orders, setOrders } = useContext(AdminOrdersContext);
  // console.log("orders***", orders);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  let auth = useContext(WithAuthentication);
  // console.log(auth);
  let parameter: any;
  let param = useParams();
  let result;
  // console.log(customerOrders);
  // console.log(superAdminOrders);
  useEffect(() => {
    async function apiHandler() {
      if (customerOrders) {
        parameter = { uid: auth.userInfo.id };
      } else if (superAdminOrders) {
        parameter = {};
      } else {
        parameter = { supplier_id: param.supplier_id };
      }
      result = await connection("api/get_all_orders", parameter);
      result.data.length > 0 && setOrders(result.data);
      // console.log("result", result);
      // ordersMain = result.data;
      // console.log(ordersMain);

      // console.log("orders", result, orders);
    }
    apiHandler();
  }, [customerOrders, superAdminOrders]);

  return (
    <>
      <PanelFormatterHOC
        // title={["سفارشات درحال انتظار", "سفارشات تکمیل شده", "گزارش"]}
        title={["سفارشات"]}
        label="orders"
        components={[<AdminOrder pageName={pageName} />]}
        // components={[
        //   <WaitingOrdersTab
        //     orders={orders?.filter((value) => value.lats_order_status != 4)}
        //   />,
        //   <CompletedOrdersTab
        //     orders={orders?.filter((value) => value.lats_order_status == 4)}
        //   />,
        //   <Report />,
        // ]}
      />
      {ReactDOM.createPortal(<OrderModal />, document.getElementById("modals"))}
    </>
  );
}
